import { show as showIntercomMessenger } from '@intercom/messenger-js-sdk'

export default showIntercomMessenger
